module.exports = __webpack_public_path__ + "img/007.f1443e21.png";